<div class="container-content" fxLayout="column">
  <app-exam-location-table-filter></app-exam-location-table-filter>
  <app-exam-location-table></app-exam-location-table>
  <app-paginator
    [filter]="filter"
    [total]="total"
    (filterApply)="load()"
  ></app-paginator>
  <app-loading-indicator-full
    *ngIf="loading"
  ></app-loading-indicator-full>
</div>
